import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { DataProvider } from "./context/DataContext";
import { Toaster } from "sonner";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Overview from "./pages/Overview";
import Capacity from "./pages/Capacity";
import Principals from "./pages/Principals";
import Allocation from "./pages/Allocation";
import Sheet from "./pages/Sheet";
import Users from "./pages/Users";
import Personnel from "./pages/Personnel";
import Leave from "./pages/Leave";
import Manual from "./pages/Manual";

import PortfolioShell from "./pages/portfolio/PortfolioShell";
import MyPortfolio from "./pages/portfolio/MyPortfolio";
import MySummary from "./pages/portfolio/MySummary";
import ProjectForm from "./pages/portfolio/ProjectForm";
import MyProjectsLayout from "./pages/portfolio/MyProjectsLayout";

export const homeFor = (role) =>
  role === "principal" ? "/portfolio/projects"
  : role === "associate" ? "/portfolio/projects"
  : role === "leave_editor" ? "/portfolio/projects"
  : "/admin/overview";

const RoleHome = () => {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center"><span className="eyebrow">loading</span></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homeFor(user.role)} replace />;
};

const AdminGuard = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to={homeFor(user.role)} replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Admin */}
          <Route path="/admin" element={
            <AdminGuard>
              <DataProvider><Dashboard /></DataProvider>
            </AdminGuard>
          }>
            <Route index element={<Navigate to="/admin/overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="sheet" element={<Sheet />} />
            <Route path="projects" element={<Navigate to="/admin/principals?view=all" replace />} />
            <Route path="capacity" element={<Capacity />} />
            <Route path="principals" element={<Principals />} />
            <Route path="allocation" element={<Allocation />} />
            <Route path="personnel" element={<Personnel />} />
            <Route path="users" element={<Users />} />
            <Route path="leave" element={<Leave />} />
            <Route path="help" element={<Manual />} />
            <Route path="my-projects" element={<MyProjectsLayout />}>
              <Route index element={<MyPortfolio />} />
              <Route path="summary" element={<MySummary />} />
              <Route path="add" element={<ProjectForm />} />
              <Route path="edit/:projectId" element={<ProjectForm />} />
            </Route>
          </Route>

          {/* Principal / associate / leave_editor portfolio */}
          <Route path="/portfolio" element={<PortfolioShell />}>
            <Route index element={<Navigate to="/portfolio/projects" replace />} />
            <Route path="projects" element={<MyPortfolio />} />
            <Route path="summary"  element={<MySummary />} />
            <Route path="capacity" element={<Capacity />} />
            <Route path="leave"    element={<Leave />} />
            <Route path="help"     element={<Manual />} />
            <Route path="add"      element={<ProjectForm />} />
            <Route path="edit/:projectId" element={<ProjectForm />} />
          </Route>

          {/* Legacy leave-editor URL — send to portfolio home. */}
          <Route path="/leave" element={<Navigate to="/portfolio/projects" replace />} />

          {/* Root → role-based redirect */}
          <Route path="/" element={<RoleHome />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
